'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import text from 'I18n/utils/unescapedText';
import { FORM, RICH_TEXT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import withContentPreview from 'DesignEditorsUI/components/shared/hoc/withContentPreview';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import Form from 'ContentComponents/cmv2/fields/Form';
import ModuleFieldMap from 'DesignEditorsUI/lib/ModuleFieldMap';
import { compose } from 'redux';
const RichTextComponent = ModuleFieldMap[RICH_TEXT];

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class FormContentOptions extends Component {
  constructor(...args) {
    super(...args);

    this.onFieldChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onRedirect = redirectToForm => {
      this.redirectPending = true;
      this.redirectToForm = redirectToForm;
    };

    this.renderRichTextField = props => /*#__PURE__*/_jsx(RichTextComponent, Object.assign({}, props, {
      modulePath: this.props.modulePath,
      shouldFetchCustomFonts: true
    }));
  }

  componentDidUpdate(prevProps) {
    if (this.redirectPending && prevProps.formIdFromBuffer !== this.props.formIdFromBuffer) {
      this.props.saveCustomWidget(this.props.customWidgetId);
    } else if (this.redirectPending && this.redirectToForm && prevProps.isSaving && !this.props.isSaving) {
      this.redirectPending = false;
      this.redirectToForm();
    }
  }

  render() {
    const {
      componentsByType
    } = this.props;

    if (!this.props.compact) {
      componentsByType[RICH_TEXT] = this.renderRichTextField;
    }

    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: text(i18nKey(`defaultLabels.${FORM}`)),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        onFieldChange: this.onFieldChange,
        value: this.props.field[DEFAULT],
        readOnly: this.props.readOnly,
        type: FORM,
        inputComponent: Form,
        onRedirect: this.onRedirect,
        componentsByType: componentsByType,
        required: false
      })
    });
  }

}

FormContentOptions.propTypes = {
  compact: PropTypes.bool,
  componentsByType: PropTypes.object.isRequired,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,

  /*
  "formIdFromBuffer" is this form field's form_id as it is in the CustomWidgetBuffers
  state, whereas the "field" prop and its form_id is actually from the FieldEditSidebar
  state (because when a new field is created it needs to consult local state
  since the new field has not yet been saved in the real module buffer)
  */
  formIdFromBuffer: PropTypes.string,
  isSaving: PropTypes.bool.isRequired,
  modulePath: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  saveCustomWidget: PropTypes.func.isRequired
};

function makeMapStateToProps() {
  const getRequestStatus = customWidgetBuffersSelectors.makeGetRequestStatus();
  const getModulePath = customWidgetBuffersSelectors.makeGetModulePath();
  return (state, props) => {
    const {
      isSaving = false
    } = getRequestStatus(state, props) || {};
    const modulePath = getModulePath(state, props);
    const isFullScreenEditorOpen = customWidgetEditorOptionsSelectors.getIsFullScreenEditorOpen(state, props);
    const fieldFromBuffer = customWidgetBuffersSelectors.getCustomWidgetBufferFieldsMap(state, {
      customWidgetId: props.customWidgetId
    })[props.field.id] || {};
    return {
      isSaving,
      modulePath,
      richTextPreviewIconName: isFullScreenEditorOpen ? 'remove' : 'expand',
      formIdFromBuffer: fieldFromBuffer[DEFAULT] && fieldFromBuffer[DEFAULT].form_id
    };
  };
}

const mapDispatchToProps = {
  saveCustomWidget: CustomWidgetBufferActions.save
};
export default compose(connect(makeMapStateToProps, mapDispatchToProps), withContentPreview)(FormContentOptions);